import ms from 'ms'

import BlogApis from '@/app/blog/apis'
import BlogPage from '@/app/blog/page'

export default BlogPage

export const getStaticPaths = async () => ({
  paths: (await BlogApis.getAll()).map(({ handle }) => ({
    params: { handle },
  })),
  fallback: false,
})

export const getStaticProps = async ({ params: { handle } }) => {
  const data = await BlogApis.getPost(handle)

  return {
    props: {
      data,
    },
    revalidate: ms('12h') / 1000,
  }
}
